import { CollectionView } from 'common';

export type SortBy = 'title' | 'date';
export type CollectionCategory = typeof collectionCategories[number];

export const collectionCategories = ['My selection', 'AdAlong suggestions', 'Social Media', 'Website', 'CRM', 'Archive'] as const;

const mainFirst = (a: CollectionView, b: CollectionView): number => {
  if (a.isFavorite && !b.isFavorite) return -1;
  if (!a.isFavorite && b.isFavorite) return 1;
  return 0;
};

export const sortComparators: Record<SortBy, (a: CollectionView, b: CollectionView) => number> = {
  title: (a, b) => mainFirst(a, b) || a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
  date: (a, b) => mainFirst(a, b) || (new Date(b.created_at) > new Date(a.created_at) ? 1 : -1),
};
